module.exports = __webpack_public_path__ + "img/img8.cf7aa162.svg";